import React from "react";
import { ImCross } from "react-icons/im";

const API_BASE = String(process.env.REACT_APP_API || "").replace(/\/$/, "");

const buildVideoSrc = (videoUrl = "") => {
    const value = String(videoUrl || "").trim();
    if (!value) return "";
    if (/^https?:\/\//i.test(value)) return value;
    return `${API_BASE}${value.startsWith("/") ? value : `/${value}`}`;
};

export default function InitialValidationVideoPopup({ open, data, loading, error, onClose }) {
    if (!open) return null;
    const src = buildVideoSrc(data?.videoUrl);
    const fullName = String(data?.fullName || "").trim();
    const dni = String(data?.dni || "").trim();
    const initialAmount = Number(data?.initialAmount || 0);

    return (
        <div className="popupConfirmPayment fadeInZoom">
            <div className="popupConfirmPayment_wrapper">
                <div className="popupConfirmPayment_content initialValidationVideoPopup">
                    <h3>VALIDACIÓN DE INICIAL</h3>
                    {loading ? (
                        <p style={{ marginTop: 14, fontWeight: 700 }}>Cargando video...</p>
                    ) : error ? (
                        <p style={{ marginTop: 14, color: "#b91c1c", fontWeight: 700 }}>{error}</p>
                    ) : (
                        <>
                            <div className="initialValidationVideoMeta">
                                {fullName ? <strong>{fullName}</strong> : null}
                                {dni ? <span>DNI: {dni}</span> : null}
                                {initialAmount > 0 ? <span>Inicial: S/ {initialAmount.toFixed(2)}</span> : null}
                            </div>
                            {src ? (
                                <video className="initialValidationVideoPlayer" src={src} controls playsInline preload="metadata" />
                            ) : (
                                <p style={{ marginTop: 14, fontWeight: 700 }}>No se encontró la ruta del video.</p>
                            )}
                        </>
                    )}
                    <div className="buttonConfirmPay" onClick={onClose} style={{ marginTop: 22, cursor: "pointer" }}>Cerrar</div>
                    <div className="checkConfirmPay" onClick={onClose} style={{ marginTop: 20 }}><div><ImCross /></div></div>
                </div>
            </div>
            <style>{`
        .initialValidationVideoPopup { max-width: 560px; width: 100%; }
        .initialValidationVideoMeta { display: grid; gap: 4px; margin: 12px 0 14px; color: #1f2937; font-size: 14px; }
        .initialValidationVideoMeta strong { color: #4d0084; font-size: 16px; }
        .initialValidationVideoPlayer { width: 100%; max-height: 62vh; background: #020617; border-radius: 14px; border: 1px solid #e5e7eb; box-shadow: 0 14px 35px rgba(15, 23, 42, .18); }
      `}</style>
        </div>
    );
}
